import { CircularProgress } from "@mui/material";
import { LoaderContainer } from "utils";
import { Document, ThumbnailType } from "types";
import { FileView } from "./index";
import { Controls as ControlledBarControls } from "./ControlledBar";
import { useReadSas } from "hooks/queries/filestore";
import { defaultThumbnails, useThumbnails } from "hooks/queries/useThumbnails";
import { useWorkspace } from "hooks/queries/useWorkspace";
import { useParams } from "react-router-dom";

export type FileViewLoaderProps = {
    document: Document;
    fileView: ThumbnailType;
    allowZoomPanPinch?: boolean;
    fallbackMessage?: boolean;
    displayHeader?: boolean,
    cursor?: string;
    additionalControls?: ControlledBarControls;
    hideFullScreenButton?: boolean,
    onClick?: () => void;
    onError?: (error: string) => void;
    onClose?: () => void;
};

export function FileViewLoader(props: FileViewLoaderProps) {
    const { workspaceId } = useParams<{ workspaceId: string; }>();
    const { document, hideFullScreenButton } = props;

    const enableThumbnails = useWorkspace(workspaceId).data?.config.filestoreConfig.enableThumbnails;

    const fileHref = useReadSas(workspaceId, document.fileId).data;

    const { data: thumbnails, isError, isLoading: isThumbnailsLoading } = useThumbnails(workspaceId, enableThumbnails ? [document.fileId] : []);

    const isLoading = isThumbnailsLoading && enableThumbnails;

    if (isLoading || !fileHref)
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}><CircularProgress /></div>
        );

    return (
        <LoaderContainer loaded={!isLoading} error={isError && "An unexpected error occured"} loadingElement={() => <CircularProgress />}>
            <FileView
                {...props}
                key={document.fileId}
                fileHref={fileHref}
                thumbnails={enableThumbnails ? thumbnails[0]?.thumbnails : defaultThumbnails(fileHref)}
                file={document}
                hideFullScreenButton={hideFullScreenButton}
            />
        </LoaderContainer>
    );
}